import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { CookieConsentService } from '@core/service/cookie-consent.service';

@Component({
  selector: 'app-cookie-consent',
  imports: [RouterLink],
  templateUrl: './cookie-consent.component.html',
  styleUrl: './cookie-consent.component.scss',
})
export class CookieConsentComponent {
  constructor(protected readonly cookieConsent: CookieConsentService) {}

  acceptAll(): void {
    this.cookieConsent.acceptAll();
  }

  rejectNonEssential(): void {
    this.cookieConsent.rejectNonEssential();
  }
}
